import './App.css';
import { useState, useEffect } from "react"
import { projectURL } from './utils/mockdata';

const TermsOfService = () => {

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  useEffect(() => {
    // Warm up the Render backend
    fetch(projectURL)
      .then(() => console.log("Render backend warmed up"))
      .catch((err) => console.warn("Render wake-up failed:", err));
  }, []);


  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50">

      {/* Header */}
      <header className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <img className="ring-2 ring-blue max-w-10 border rounded-full p-1.5" src="icon.jpg" alt="Socio" />
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              Socio
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/#features" className="text-gray-600 hover:text-purple-600 transition-colors">
              Features
            </a>
            <a href="/#community" className="text-gray-600 hover:text-purple-600 transition-colors">
              Community
            </a>
            <a href="/#about" className="text-gray-600 hover:text-purple-600 transition-colors">
              About
            </a>
            <a href="/login" className="px-4 py-2 border border-purple-200 text-purple-600 hover:bg-purple-50 bg-transparent rounded-md transition-colors">
              Log In
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-md text-gray-600 hover:text-purple-600 hover:bg-gray-100 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4 pt-4">
              <a
                href="/#features"
                className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Features
              </a>
              <a
                href="/#community"
                className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Community
              </a>
              <a
                href="/#about"
                className="text-gray-600 hover:text-purple-600 transition-colors py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </a>
              <a target="__blank" href="/login" className="w-full mt-4 px-4 py-2 border border-purple-200 text-purple-600 hover:bg-purple-50 bg-transparent rounded-md transition-colors text-left">
                Log In
              </a>
            </nav>
          </div>
        )}
      </header>

      <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800">
        <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
        <p className="mb-4 text-sm text-gray-500">Effective Date: 07-07-2025</p>

        <p className="mb-4">
          Welcome to My Social Platform ("we", "our", or "us"). These Terms of Service ("Terms") govern your use of our website at{" "}
          <a href="https://socioapp.live/" className="text-blue-600 underline">
            https://socioapp.live/
          </a>{" "}
          (the "Site"). By accessing or using our Site, you agree to be bound by these Terms.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">1. Use of the Site</h2>
        <p className="mb-4">
          You agree to use the Site in accordance with all applicable laws and regulations. You must not:
        </p>
        <ul className="list-disc list-inside mb-4">
          <li>Use the Site for any unlawful purpose</li>
          <li>Attempt to gain unauthorized access to any part of the Site</li>
          <li>Disrupt or interfere with the security or functionality of the Site</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. User Accounts</h2>
        <p className="mb-4">
          To access certain features, you may be required to create an account. You are responsible for maintaining
          the confidentiality of your login credentials and for all activities under your account.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Content Ownership</h2>
        <p className="mb-4">
          You retain ownership of any content you post on the Site. By posting content, you grant us a non-exclusive,
          royalty-free, worldwide license to use, display, and distribute it as part of the service.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Termination</h2>
        <p className="mb-4">
          We may suspend or terminate your access to the Site at our discretion, without notice, if you violate these Terms
          or use the Site in a harmful manner.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Disclaimer</h2>
        <p className="mb-4">
          The Site is provided "as is" without warranties of any kind. We do not guarantee the accuracy, reliability,
          or availability of the Site or its content.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
        <p className="mb-4">
          We shall not be liable for any indirect, incidental, or consequential damages arising from your use of the Site.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">7. Modifications</h2>
        <p className="mb-4">
          We reserve the right to update or modify these Terms at any time. Continued use of the Site after changes
          means you accept the revised Terms.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">8. Governing Law</h2>
        <p className="mb-4">
          These Terms are governed by and construed in accordance with the laws of your jurisdiction.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Us</h2>
        <p className="mb-2">
          If you have any questions about these Terms, please contact us at:
        </p>
        <p className="font-medium">📧 Email: socioapplive@gmail.com</p>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <img className="ring-2 ring-blue max-w-10 border rounded-full p-1.5" src="socio_icon-removebg-preview.png" alt="Socio" />
                </div>
                <span className="text-xl font-bold">Socio</span>
              </div>
              <p className="text-gray-400">Connecting people and communities around the world.</p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="/#features" className="hover:text-white transition-colors">
                    Features
                  </a>
                </li>
                {/* <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Pricing
                  </a>
                </li> */}
                <li>
                  <a href="Socio.apk" className="hover:text-white transition-colors">
                    Mobile App
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="/#about" className="hover:text-white transition-colors">
                    About
                  </a>
                </li>
                {/* <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition-colors">
                    Press
                  </a>
                </li> */}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="/HelpCenter" className="hover:text-white transition-colors">
                    Help Center
                  </a>
                </li>
                <li>
                  <a href="/PrivacyPolicy" className="hover:text-white transition-colors">
                    Privacy
                  </a>
                </li>
                <li>
                  <a href="/TermsOfService" className="hover:text-white transition-colors">
                    Terms
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2026 Socio. All rights reserved.</p>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default TermsOfService;

